export function traverseUpwardsTo(from, toNodeType, callback) {
    while (from && from.nodeName.toLowerCase() !== toNodeType && from.parentElement) {
        callback(from);
        from = from.parentElement;
    }
}

export function findNodeUpwards(from, toNodeType) {
    while (from && from.parentElement) {
        if (from.nodeName.toLowerCase() === toNodeType) {
            return from;
        }

        from = from.parentElement;
    }

    return null;
}

export function findNodeUpwardsByClass(from, toNodeClassType) {
    while (from && from.parentElement) {
        if (from.classList.contains(toNodeClassType)) {
            return from;
        }

        from = from.parentElement;
    }

    return null;
}

export function getMeta(metaName) {
    const metaEl = document.querySelector(`meta[name='${metaName}']`);

    if (!metaEl) {
        return '';
    }

    return metaEl.content;
}

export function dashboardRoot() {
    return getMeta('dashboard-root');
}

export function dashboardCurrentModule() {
    return getMeta('dashboard-current-module');
}

export function dashboardCurrentController() {
    return getMeta('dashboard-current-controller');
}

export function dashboardCurrentAction() {
    return getMeta('dashboard-current-action');
}

export function dashboardCurrentActionParams() {
    return JSON.parse(getMeta('dashboard-current-action-params'));
}

export function dashboardAction(module, controller, action, parameters = []) {
    let params = '';

    if (parameters.length) {
        params = '/' + parameters.join('/');
    }

    return `${dashboardRoot()}action/${module}/${controller}/${action}${params}`;
}

export function dashboardModuleAction(action, parameters = []) {
    return dashboardAction(dashboardCurrentModule(), dashboardCurrentController(), action, parameters);
}

export function dashboardGetCurrentViewKey() {
    let key = `${dashboardCurrentModule()}_${dashboardCurrentController()}_${dashboardCurrentAction()}_${dashboardCurrentActionParams().join('_')}`;
    key = key.replaceAll('-', '_');

    return key;
}

export function dashboardConfirmAction(route, action = 'confirmAction') {
    return `${dashboardRoot()}action/${dashboardCurrentModule()}/${dashboardCurrentController()}/${action}/${base64UrlEncode(route)}`;
}

export function getDashboardLanguage() {
    const code = document.documentElement.lang;

    if (code) {
        return code;
    }

    return undefined;
}

export function base64UrlEncode(data) {
    const utf8Bytes = new TextEncoder().encode(data);
    const base64 = btoa(String.fromCharCode.apply(null, utf8Bytes));
    const urlSafeBase64 = base64.replace(/\+/g, '-').replace(/\//g, '_');
    return urlSafeBase64.replace(/=+$/, '');
}

export function base64UrlDecode(data) {
    const urlEncodedStr = data.replace(/-/g, '+').replace(/_/g, '/');
    const paddedEncodedStr = urlEncodedStr.padEnd(urlEncodedStr.length + (4 - urlEncodedStr.length % 4) % 4, '=');
    const byteCharacters = atob(paddedEncodedStr);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const utf8Bytes = new Uint8Array(byteNumbers);
    return new TextDecoder().decode(utf8Bytes);
}

export function debounce(func, timeout = 300) {
    let timer = null;

    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func.apply(this, args);
        }, timeout);
    };
}

export function once(fn) {
    let called = false;

    return function () {
        if (called) {
            return;
        }

        called = true;

        fn(...arguments);
    };
}

export function makeDebouncedLoad(fn) {
    let lastCallback = null;
    const debouncedFn = debounce(fn, 300);

    return function (query, callback) {
        const newCallback = once(callback);

        if (lastCallback) {
            lastCallback();
            debouncedFn(query, newCallback);
        } else {
            fn(query, newCallback);
        }

        lastCallback = newCallback;
    };
}
